var $47234f3018c55486$exports = {};
$47234f3018c55486$exports = {
    "dismiss": `Ignora`
};


export {$47234f3018c55486$exports as default};
//# sourceMappingURL=it-IT.mjs.map
